<template>
  <vs-row>
      <vs-row class="mb-3 mt-2">
        <h4>History Log</h4>
        <vs-spacer />
        <vs-button
          v-if="username !== 'i-APCdemo'"
          class="ml-auto p-0"
          type="flat"
          @click="linkpage()"
          color="success"
        >
          <vs-icon icon="add"></vs-icon>View More
        </vs-button>
        <!-- <vs-tooltip  text="Print" position="top" >
          <vs-button  radius class="mr-2"  color="#333f50" @click="print" type="line"   icon="print"></vs-button></vs-tooltip>
           <vs-tooltip  text="Download a PDF" position="top" >
          <vs-button  radius class="mr-2"  color="#333f50" @click="exportPDF" type="line"   icon="picture_as_pdf"></vs-button></vs-tooltip>
          <vs-tooltip  text="Export" position="top" >
          <vs-button   radius  color="#333f50" @click="onExport" type="line"  icon="cloud_download"></vs-button></vs-tooltip> -->
      </vs-row>
    <vs-col>
    

      <div class="table-responsive">
        <vs-table :hoverFlat="false" :data="read" style="color: #333f50">
          
          <template slot="thead">
            <vs-th
              id="noWrap"
              sort-key="name"
              v-for="(head, indexh) in list"
              :key="indexh"
            >
              {{ head }}
              <span><vs-icon icon="unfold_more" size="13px"></vs-icon></span>
            </vs-th>
          </template>
          <template slot-scope="{ data }">
            <vs-tr id="fontSizeData" :key="indextr" v-for="(tr, indextr) in data">
              <vs-td v-if="username != 'poonsak.ngk' && type != 'monnit'">
                {{ name }}
              </vs-td>
              <vs-td :key="indextd" v-for="(td, indextd) in tr">
                <div
                  v-if="
                    indextd == 'time' ||
                    indextd == 'timestamp' ||
                    indextd == 'date' ||
                    indextd == 't'
                  "
                >
                  {{ $moment(tr[indextd]).format("YYYY-MM-DD HH:mm:ss") }}
                </div>
                <div v-else>
                  {{ tr[indextd] }}
                </div>
              </vs-td>
            </vs-tr>
          </template>
        </vs-table>
      </div>
    </vs-col>
  </vs-row>
</template>
<script>
import moment from "moment";
import XLSX from "xlsx"; // import xlsx
import html2pdf from "html2pdf.js";
import jsPDF from "jspdf";
import "jspdf-autotable";
export default {
  name: "State",
  props: ["id", "gid", "calldata", "nwid", "type", "nwname", "name"],
  data: () => ({
    read: [],
    dataform: {
      data: "",
      date: 0,
    },
    list: [],
    logdata: [],
    username: "",
    namesansor: "ffkof",
  }),
  methods: {
    linkpage() {
      this.$router.push({
        name: "SensorPage",
        params: {
          data: this.read,
          sensorid: this.id,
          gatewayid: this.gid,
          nwid: this.nwid,
          type: this.type,
          nwname: this.nwname,
          list: this.list,
        },
      });
    },
    // export xlsx
    onExport() {
      const dataWS = XLSX.utils.json_to_sheet(this.logdata);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, dataWS);
      XLSX.writeFile(wb, "exportLogData.xlsx");
    },
    print() {
      console.log(this.read);
      console.log(this.list);
    },
    // export PDF
    exportPDF() {
      console.log(this.sensorlist);
      // this.sensorlist.forEach(element => {
      //    this.dataBody.push({name: element.name,serial_id: element.serial_id,type: element.type,network: element.network,location: element.location,active: element.active, signal:'100',bat:'100'});
      // });
      // console.log(this.dataBody)
      var doc = new jsPDF("p", "pt");
      doc.setFontSize(11).text("Sensor List", 40, 40); //header
      var newDat = moment().format("MM/DD/YYYY hh:mm:ss");
      doc.setFontSize(7).text(505, 25, newDat); //timestamp
      var values = this.read.map((elemento) => Object.values(elemento));
      console.log(values);
      doc.autoTable({
        theme: "striped",
        headStyles: { fillColor: [105, 181, 83], textColor: [255, 255, 255] },
        styles: { fontSize: 8, theme: "plain" },
        head: [this.list],
        body: values,
        margin: { top: 50 },
      });
      doc.save("exportSensorList.pdf");
      this.dataBody = []; //Clear dataBody
    },
  },
  created() {
    this.username = this.$session.get("username");
    this.calldata.forEach((element) => {
      this.logdata.push(element);
    });
    switch (this.type) {
      case "control":
        // eslint-disable-next-line no-console
        // console.log(this.logdata[0])
        this.logdata.forEach((e, i) => {
          delete this.logdata[i].serial_id;
          delete this.logdata[i].id;
          delete this.logdata[i].control;
          delete this.logdata[i].jtimestamp;
          delete this.logdata[i].Timestamp;
          this.logdata[i].timestamp = this.$moment(
            this.$moment(this.logdata[i].timestamp).subtract(7, "hours")
          ).format("YYYY-MM-DD HH:mm:ss");
        });
        if (this.username != "poonsak.ngk") {
          this.list.push("name");
        }
        Object.keys(this.logdata[0]).forEach((e) => {
          this.list.push(e);
        });
        break;
      default:
        console.log(this.logdata)
        this.logdata.forEach((e, i) => {
          delete this.logdata[i].name;
          delete this.logdata[i].ID;
          delete this.logdata[i].labels;
          delete this.logdata[i].EndNode;
          delete this.logdata[i].AccessPoint;
          if (this.username == "QCONdemo") {
            delete this.logdata[i].battery;
            delete this.logdata[i].rssi;
          }
        });
        if(this.type != 'monnit')
        if(this.type == 'advantech' || this.type == 'ssc') this.list.push("Serial ID")
        else this.list.push("Sensor Name");
        // Object.keys(this.logdata[0]).forEach((e) => {
        //   if(e == 'timestamp' || e == 't' || e == 'Timestamp' || e == 'date' || e == 'time') {
        //     this.list.push('Timestamp')
        //   }
        // })
        Object.keys(this.logdata[0]).forEach((e) => {
          if (e == "gatewayid") {
            this.list.push("gateway id");
          } else if (e == "sensorid") {
            this.list.push("sensor id");
          } else if (e == "sensorname") {
            this.list.push("sensor name");
          } else if (e == "messagedate") {
            this.list.push("message date");
          } else if (e == "datatype") {
            this.list.push("data type");
          } else if (e == "datavalue") {
            this.list.push("data value");
          } else {
            this.list.push(e);
          }
        });
        break;
    }
    if (this.type == "powermeter") {
      for (let i = this.logdata.length - 1; i >= this.logdata.length - 6; i--) {
        this.logdata[i].Timestamp = this.$moment(
          this.logdata[i].Timestamp
        ).format("YYYY-MM-DD HH:mm:ss");
        this.read.push(this.logdata[i]);
      }
    } else {
      for (let i = 0; i < 5; i++) {
        if (this.logdata[i]) {
          if(this.type == 'lora') {
            this.logdata[i].time = this.$moment(
              this.$moment(this.logdata[i].time).subtract(7, "hours")
            ).format("YYYY-MM-DD HH:mm:ss");
          }
          this.read.push(this.logdata[i]);
        }
      }
    }
    console.log(this.read)
  },
};
</script>
<style scoped>
#noWrap {
  padding: 0px;
  white-space: nowrap;
  font-size: 0.75rem
}
.wrapper.overflow {
  overflow-y: scroll;
  max-height: 250px;
}
</style>
<style>
th .vs-table-text {
  text-transform: capitalize;
}
.con-slot-label {
  text-transform: capitalize;
}
</style>
